import sliceCreator from '../../index.jsx';
import {GET_DAILY_PUNCH_BY_ID} from '../../../constants/index.jsx';
const _getDailyPunchByIdAction = sliceCreator('GET_DAILY_PUNCH_BY_ID', GET_DAILY_PUNCH_BY_ID, 'get');

const { asyncAction: getDailyPunchByIdAction, reducer, clearData: clearGetDailyPunchByIdAction } = _getDailyPunchByIdAction;

export default reducer;

export {
    getDailyPunchByIdAction,
    clearGetDailyPunchByIdAction
}